import { BonhamsChannel } from '@nx/external/pusher'

export const lotChannelVersion = 1

export const buildLotChannelName = (lotUniqueId: string): BonhamsChannel =>
  `cache-lot-${lotUniqueId}-v${lotChannelVersion}`
